import React from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { Link } from 'react-router-dom';
import { ImageResizer } from '../../Types/ImageResizer';
import { ReactComponent as Vector } from '../Icons/vector.svg';

import './GlobalInfoSection.scss';
import { useSessionStorage } from '../../hooks/useSessionStorage';

interface GlobalInfoSectionProps {
	scrollToPlanner: boolean;
	title: string;
	titleUa: string;
	subTitle?: string;
	subTitleUa?: string;
	image: ImageResizer;
	buttonText?: string;
	buttonTextUa?: string;
	quote?: boolean;
}

export default function GlobalInfoSection({
	scrollToPlanner,
	title,
	titleUa,
	subTitle,
	subTitleUa,
	image,
	buttonText,
	buttonTextUa,
	quote,
}: GlobalInfoSectionProps) {
	const [language] = useSessionStorage('language', '');
	return (
		<div className="globalInfoSection">
			<div className="globalInfoSectionContent">
				<div className="backgroundImage">
					<Vector className="globalInfoSectionVector" />
					<img className={quote ? 'quoteGlobalInfoSectionImage' : 'globalInfoSectionImage'} src={image.md.src} alt=""></img>
				</div>
				<div className="globalInfoSectionInfo">
					<div className="globalInfoSectionTitle">{language === 'ua' && titleUa ? titleUa : title}</div>
					{subTitle && (
						<div
							className="globalInfoSectionDescription"
							dangerouslySetInnerHTML={{ __html: `${language === 'ua' && subTitleUa ? subTitleUa : subTitle}` }}
						></div>
					)}
					{buttonText &&
						(scrollToPlanner ? (
							<ScrollLink to="projectPlannerSectionScroll" smooth={true} className="globalInfoSectionBtn" offset={-100}>
								{language === 'ua' && buttonTextUa ? buttonTextUa : buttonText}
							</ScrollLink>
						) : (
							<Link to="/vacancies" className="globalInfoSectionBtn">
								{language === 'ua' && buttonTextUa ? buttonTextUa : buttonText}
							</Link>
						))}
				</div>
			</div>
		</div>
	);
}
